const { NODE_ENV, REACT_APP_API_URL } = process.env;

const API_URL =
  NODE_ENV === 'development' ? REACT_APP_API_URL : REACT_APP_API_URL;

export default API_URL;
